import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const subscriptionsStatusListWidget: DashboardWidgetConfiguration = {
  widgetId: "subscriptions.status-list",
  name: "Subscriptions by status",
  description: "Subscriptions by status as a compact RQL list.",
  apps: [
    "subscriptions",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "subscriptions.records",
      ...period(30),
      select: [
        {
          type: "field",
          field: "status",
          as: "status",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "record_id",
          as: "subscriptions",
        },
      ],
      group_by: [
        {
          field: "status",
        },
      ],
      order_by: [
        {
          ref: "subscriptions",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Subscriptions by status",
    columns: [
      {
        key: "status",
        label: "Status",
      },
      {
        key: "subscriptions",
        label: "Subscriptions",
        align: "end",
        format: "number",
      },
    ],
    maxRows: 8,
    showAccountTypeDescription: false,
  },
  dummyData: {
    rows: [
      {
        status: "Active",
        subscriptions: 248,
      },
      {
        status: "Trial",
        subscriptions: 36,
      },
      {
        status: "Paused",
        subscriptions: 12,
      },
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
